export interface ICollection<T> {
  Add(key: string, value: T);
  ContainsKey(key: string): boolean;
  Count(): number;
  Item(key: string): T;
  Keys(): string[];
  Remove(key: string): T;
  Values(): T[];
  Clear();
}

export class Dictionary<T> implements ICollection<T> {
  private _items: { [index: string]: T };
  private _count: number;

  public constructor() {
    this.Clear();
  }

  ContainsKey(key: string): boolean {
    return this._items.hasOwnProperty(key);
  }

  Count(): number {
    return this._count;
  }

  Add(key: string, value: T) {
    if (!this._items.hasOwnProperty(key)) {
      this._count++;
    }

    this._items[key] = value;
  }

  Remove(key: string): T {
    const val = this._items[key];
    delete this._items[key];
    this._count--;

    if (this._count < 0) {
      this._count = 0;
    }

    return val;
  }

  Item(key: string): T {
    return this._items[key];
  }

  Keys(): string[] {
    const keySet: string[] = [];

    for (const prop in this._items) {
      if (this._items.hasOwnProperty(prop)) {
        keySet.push(prop);
      }
    }

    return keySet;
  }

  Values(): T[] {
    const values: T[] = [];

    for (const prop in this._items) {
      if (this._items.hasOwnProperty(prop)) {
        values.push(this._items[prop]);
      }
    }

    return values;
  }

  Clear() {
    this._items = {};
    this._count = 0;
  }
}
